/**
 * Get environment variable with fallback
 */
export const getEnvVar = (key: string, fallback = ''): string => {
  // Check both runtime window config and import.meta.env
  const windowConfig = (window as any).FN_CONFIG;
  const envValue = windowConfig?.[key] || import.meta.env[key] || fallback;
  return envValue;
};
